export const emailData = [
  {
    liked: true,
    img: 'assets/images/user/1.jpg',
    name: 'Pork Lorn',
    mailDace:
      'Account recovered successfully. Welcome back to your accountIf you suspect you were locked out of your account because of changes made.',
    time: '11:59 PM',
    icon: 'like',
  },
  {
    liked: false,
    img: 'assets/images/user/2.png',
    name: 'Dee Deo',
    mailDace:
      'Art by Jack Daly Apply now: Graphic Designer @Shell The world is changing fast, and Shell is changing too–not only to keep up with the external pace.',
    time: '09:59 AM',
  },
  {
    liked: true,
    img: 'assets/images/user/3.jpg',
    name: 'Peg Legge',
    mailDace:
      'Your password was changed. The password for your Google account was changed. If you didnt change it, you should recover your account.',
    time: '07:59 AM',
  },
  {
    liked: true,

    img: 'assets/images/user/4.jpg',
    name: 'Olive Yew',
    mailDace:
      'Looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage.',
    time: '05:59 PM',
  },
  {
    liked: true,

    img: 'assets/images/user/5.jpg',
    name: 'Abby Normal',
    mailDace:
      'Account recovered successfully. Welcome back to your accountIf you suspect you were locked out of your account because of changes made.',
    time: '09:29 AM',
  },
  {
    liked: true,

    img: 'assets/images/user/6.jpg',
    name: 'Clyde Stale',
    mailDace:
      'Art by Jack Daly Apply now: Graphic Designer @Shell The world is changing fast, and Shell is changing too–not only to keep up with the external pace.',
    time: '06:03 PM',
  },
  {
    liked: true,

    img: 'assets/images/user/7.jpg',
    name: 'Art Decco',
    mailDace:
      'Your password was changed. The password for your Google account was changed. If you didnt change it, you should recover your account.',
    time: '01:11 AM',
  },
  {
    img: 'assets/images/user/8.jpg',
    name: 'Hugo First',
    mailDace:
      'Account recovered successfully. Welcome back to your accountIf you suspect you were locked out of your account because of changes made.',
    time: '09:09 AM',
  },
  {
    liked: true,

    img: 'assets/images/user/9.jpg',
    name: 'Col Fays',
    mailDace:
      'On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment.',
    time: '06:10 PM',
  },
  {
    img: 'assets/images/user/10.jpg',
    name: 'Toi Story',
    mailDace:
      'Art by Jack Daly Apply now: Graphic Designer @Shell The world is changing fast, and Shell is changing too–not only to keep up with the external pace.',
    time: '09:59 AM',
  },
  {
    liked: true,

    img: 'assets/images/user/11.png',
    name: 'Jen Tile',
    mailDace:
      'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system.',
    time: '00:59 AM',
  },
  {
    img: 'assets/images/user/12.png',
    name: 'Jen Tile',
    mailDace:
      'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system.',
    time: '00:59 PM',
  },
];
